import React from 'react';
import Input from '../../../Components/Input';
import ActionSelector from '../ActionSelector';
import DimensionSelector from '../DimensionSelector';
import MediaSelector from '../MediaSelector';
import PositionSelector from '../PositionSelector';
import { BuilderActionType, BuilderContext } from '../state';
import VendexElement, { VendexVideoMeta } from '../../../Model/VendexElement';
import VendexAction from '../../../Model/VendexAction';
import Select from '../../../Components/Select';
import { BuilderField, BuilderFieldGrid } from '../BuilderFields';

type Props = {
    element: VendexElement;
};

function VideoDetail({ element }: Props) {
    const data = element.metaData as VendexVideoMeta;

    const { dispatch } = React.useContext(BuilderContext);

    const handleChange = (value: VendexElement) => {
        dispatch({
            type: BuilderActionType.UPDATE_ELEMENT,
            payload: value,
        });
    };

    const handleDataChange = (name: string, value: string | boolean) => {
        handleChange({
            ...element,
            metaData: { ...data, [name]: value },
        });
    };

    const handleActionChange = (actions: VendexAction[]) => {
        handleChange({
            ...element,
            actions,
        });
    };

    return (
        <>
            <BuilderFieldGrid>
                <BuilderField label="Type">
                    <Select
                        onChange={(e) => {
                            handleDataChange('type', e.target.value);
                        }}
                        value={data.type}
                    >
                        <option value="STATIC">STATIC</option>
                        <option value="DYNAMIC">DYNAMIC</option>
                    </Select>
                </BuilderField>
                <BuilderField label="Muted">
                    <Select
                        value={data.muted ? 'Yes' : 'No'}
                        onChange={(e) =>
                            handleDataChange('muted', e.target.value === 'Yes')
                        }
                    >
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </Select>
                </BuilderField>
                <BuilderField label="Autoplay">
                    <Select
                        value={data.autoplay ? 'Yes' : 'No'}
                        onChange={(e) =>
                            handleDataChange(
                                'autoplay',
                                e.target.value === 'Yes',
                            )
                        }
                    >
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </Select>
                </BuilderField>
                <BuilderField label="Loop">
                    <Select
                        value={data.loop ? 'Yes' : 'No'}
                        onChange={(e) =>
                            handleDataChange('loop', e.target.value === 'Yes')
                        }
                    >
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </Select>
                </BuilderField>
                <BuilderField
                    label="Source"
                    className="md:col-span-2"
                    helperText={
                        data.type === 'STATIC'
                            ? 'Choose an uploaded video asset.'
                            : 'Provide the dynamic data key to resolve at runtime.'
                    }
                >
                    {data.type === 'STATIC' ? (
                        <MediaSelector
                            url={data.source}
                            onChange={(value) =>
                                handleDataChange('source', value)
                            }
                            type="VIDEO"
                        />
                    ) : (
                        <Input
                            value={data.source}
                            onChange={(e) =>
                                handleDataChange('source', e.target.value)
                            }
                        />
                    )}
                </BuilderField>
            </BuilderFieldGrid>
            <PositionSelector selector={`#${element.id}`} />
            <DimensionSelector selector={`#${element.id}`} />
            <ActionSelector
                actions={element.actions}
                onChange={handleActionChange}
            />
        </>
    );
}

export default VideoDetail;
